<template>
  <div class="input-wrap">
    <label v-if="label !== 'none'" for=""
      >{{ label }}
      <span v-if="required" class="required">※必須</span>
    </label>
    <span class="valid" v-if="alert">
      入力項目が空または正しい形式ではありません。</span
    >
    <select :name="setKey" @change="updateValue">
      <template v-for="(option, index) in options">
        <option
          :value="option.value"
          :selected="('00' + option.value).slice(-2) === setValue"
          :key="index"
        >
          {{ option.prefName }}
        </option>
      </template>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    options: { type: Array, required: true },
    label: { type: String, required: true },
    value: { type: String, required: true, default: null },
    setKey: { type: String, required: true },
    alert: { type: Boolean, required: false },
    required: { type: Boolean, required: false },
  },
  methods: {
    updateValue(e) {
      this.$emit('input-emit', this.setKey, e.target.value)
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.value) {
        this.$emit('input-emit', this.setKey, this.options[0].value)
      }
    })
  },
  computed: {
    setValue() {
      if (this.value || this.value === 0) {
        return ('00' + this.value).slice(-2)
      } else {
        return String(this.value)
      }
    },
  },
}
</script>
